import { render, staticRenderFns } from "./BtnDetalharPagamento.vue?vue&type=template&id=ec0dd4ca&slot=acoes&slot-scope=data"
import script from "./BtnDetalharPagamento.vue?vue&type=script&lang=js"
export * from "./BtnDetalharPagamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports